import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=12d5318a&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=ts"
export * from "./UserIcon.vue?vue&type=script&lang=ts"
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=12d5318a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d5318a",
  null
  
)

export default component.exports